const DOMAIN_SUFFIX = ' - globaldatabase.com';
const LEGACY_BRAND_SUFFIX = ' | Global Database';

// Ensure a meta title/description ends with the brand `- globaldatabase.com`.
// Strips a trailing legacy `| Global Database` first; idempotent.
export const withDomainSuffix = (value: string): string => {
  const trimmed = value.trimEnd();
  if (trimmed.endsWith(DOMAIN_SUFFIX)) return trimmed;
  const base = trimmed.endsWith(LEGACY_BRAND_SUFFIX)
    ? trimmed.slice(0, -LEGACY_BRAND_SUFFIX.length).trimEnd()
    : trimmed;
  return `${base}${DOMAIN_SUFFIX}`;
};
